import { render, staticRenderFns } from "./MenuList.vue?vue&type=template&id=31b7f54a&scoped=true&"
import script from "./MenuList.vue?vue&type=script&lang=js&"
export * from "./MenuList.vue?vue&type=script&lang=js&"
import style0 from "./MenuList.vue?vue&type=style&index=0&id=31b7f54a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b7f54a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MenuItem: require('/home/bitrix/frontend/components/sidebars/MenuAside/MenuItem.vue').default})
